<template>
  <head>
    <meta charset="utf-8" />
    <title>System | User Categories</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Multi-system role management" name="description" />
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">
                  User Account Categories
                  <span v-if="loading.categories" class="spinner-border spinner-border-sm ms-2" role="status"></span>
                </h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Settings</a></li>
                    <li class="breadcrumb-item active">User Categories</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Toast Notifications -->
          <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055;">
            <div v-if="message"
                 class="toast show align-items-center text-white border-0"
                 :class="messageType === 'success' ? 'bg-success' : 'bg-danger'"
                 role="alert">
              <div class="d-flex">
                <div class="toast-body">
                  <i :class="messageType === 'success' ? 'mdi mdi-check-circle me-2' : 'mdi mdi-alert-circle me-2'"></i>
                  {{ message }}
                </div>
                <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="clearMessage"></button>
              </div>
            </div>
          </div>

          <!-- Main Content -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">
                      <i class="mdi mdi-account-group me-2 text-primary"></i>
                      All User Categories
                    </h5>
                    <div class="d-flex gap-2">
                      <!-- System Filter -->
                      <select v-model="filterSystemID" class="form-select" style="width: 200px;" @change="filterCategories">
                        <option value="">All Systems</option>
                        <option v-for="system in systems" :key="system.id" :value="system.id">
                          {{ system.name }}
                        </option>
                      </select>

                      <button v-if="getRight('CREATE USER CATEGORY')"
                              @click="addNewCategory"
                              class="btn btn-primary"
                              data-bs-toggle="modal"
                              data-bs-target="#categoryModal">
                        <i class="mdi mdi-plus me-1"></i> Add Category
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-header bg-light border-bottom">
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <div class="search-box">
                        <div class="position-relative">
                          <input type="text" class="form-control" placeholder="Search categories..." v-model="searchTerm">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8 text-end">
                      <span class="badge bg-primary me-2">{{ filteredCategories.length }} Categories</span>
                      <span class="badge bg-success">{{ totalUsers }} Total Users</span>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading State -->
                  <div v-if="loading.categories" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2 text-muted">Loading categories...</p>
                  </div>

                  <!-- Categories Table -->
                  <div v-else class="table-responsive">
                    <table class="table table-hover table-striped align-middle">
                      <thead class="table-dark">
                      <tr>
                        <th style="width: 50px;">#</th>
                        <th>Category Name</th>
                        <th>System</th>
                        <th style="width: 100px;">Users</th>
                        <th style="width: 150px;">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in filteredCategories" :key="item.id">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <strong>{{ item.category }}</strong>
                        </td>
                        <td>
                            <span class="badge" :class="getSystemBadgeClass(item.systemID)">
                              <i :class="getSystemIcon(item.systemID)" class="me-1"></i>
                              {{ item.systemName || 'Revenue' }}
                            </span>
                        </td>
                        <td>
                          <span class="badge bg-primary rounded-pill">{{ item.count || 0 }}</span>
                        </td>
                        <td>
                          <div class="btn-group" role="group">
                            <button v-if="getRight('DELETE USER CATEGORY')"
                                    @click="deleteCategory(item)"
                                    class="btn btn-sm btn-outline-danger"
                                    title="Delete">
                              <i class="mdi mdi-delete-outline"></i>
                            </button>
                            <button v-if="getRight('EDIT USER CATEGORY')"
                                    @click="selectCategory(item)"
                                    class="btn btn-sm btn-outline-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#categoryModal"
                                    title="Edit">
                              <i class="mdi mdi-pencil-outline"></i>
                            </button>
                            <button @click="selectCategory(item)"
                                    class="btn btn-sm btn-outline-success"
                                    data-bs-toggle="modal"
                                    data-bs-target="#categoryModal"
                                    title="View">
                              <i class="mdi mdi-eye-outline"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="filteredCategories.length === 0">
                        <td colspan="5" class="text-center py-4 text-muted">
                          <i class="mdi mdi-folder-open-outline display-4 d-block mb-2"></i>
                          No categories found
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Category Modal -->
      <div class="modal fade" id="categoryModal" tabindex="-1" data-bs-backdrop="static">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title text-white">
                <i class="mdi mdi-shield-account me-2"></i>
                {{ category.id ? 'Edit' : 'Create' }} User Category
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>

            <div class="modal-body">
              <!-- Loading State -->
              <div v-if="loading.roles" class="text-center py-5">
                <div class="spinner-border text-primary" role="status"></div>
                <p class="mt-2 text-muted">Loading roles and permissions...</p>
              </div>

              <div v-else>
                <!-- Basic Info -->
                <div class="row mb-4">
                  <div class="col-md-6">
                    <label class="form-label fw-bold">Category Name <span class="text-danger">*</span></label>
                    <input v-model="category.category"
                           type="text"
                           class="form-control"
                           placeholder="e.g., Revenue Officer, Hospital Admin">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label fw-bold">Primary System <span class="text-danger">*</span></label>
                    <select v-model="category.systemID" class="form-select" @change="onSystemChange">
                      <option value="">Select System</option>
                      <option v-for="system in systems" :key="system.id" :value="system.id">
                        {{ system.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <!-- System Access (for admins who can manage multiple systems) -->
                <div class="row mb-4">
                  <div class="col-12">
                    <label class="form-label fw-bold">
                      <i class="mdi mdi-key me-1"></i>
                      Systems This Category Can Manage Roles For
                    </label>
                    <div class="d-flex flex-wrap gap-3">
                      <div v-for="system in systems" :key="system.id" class="form-check">
                        <input class="form-check-input"
                               type="checkbox"
                               :id="'sysAccess' + system.id"
                               :value="system.id"
                               v-model="systemAccessArray">
                        <label class="form-check-label" :for="'sysAccess' + system.id">
                          <i :class="system.icon" class="me-1"></i>
                          {{ system.name }}
                        </label>
                      </div>
                    </div>
                    <small class="text-muted">Select which systems' roles this category can assign to other users</small>
                  </div>
                </div>

                <!-- System Tabs for Roles -->
                <ul class="nav nav-tabs nav-tabs-custom" role="tablist">
                  <li class="nav-item" v-for="(systemData) in rightsData" :key="systemData.system.id">
                    <a class="nav-link"
                       :class="{ active: activeSystemTab === systemData.system.id }"
                       @click="activeSystemTab = systemData.system.id"
                       href="javascript:void(0)">
                      <i :class="systemData.system.icon" class="me-1"></i>
                      {{ systemData.system.name }}
                      <span class="badge bg-secondary ms-1">{{ getSelectedCountForSystem(systemData.system.id) }}</span>
                    </a>
                  </li>
                </ul>

                <!-- Roles Content -->
                <div class="tab-content border border-top-0 p-3" style="max-height: 500px; overflow-y: auto;">
                  <div v-for="systemData in rightsData"
                       :key="systemData.system.id"
                       class="tab-pane"
                       :class="{ 'active show': activeSystemTab === systemData.system.id }">

                    <!-- Quick Actions -->
                    <div class="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                      <div>
                        <button class="btn btn-sm btn-outline-primary me-2" @click="selectAllForSystem(systemData.system.id)">
                          <i class="mdi mdi-checkbox-multiple-marked me-1"></i> Select All
                        </button>
                        <button class="btn btn-sm btn-outline-secondary" @click="deselectAllForSystem(systemData.system.id)">
                          <i class="mdi mdi-checkbox-multiple-blank-outline me-1"></i> Deselect All
                        </button>
                      </div>
                      <span class="text-muted">
                        {{ getSelectedCountForSystem(systemData.system.id) }} selected
                      </span>
                    </div>

                    <!-- Role Groups -->
                    <div class="row">
                      <div v-for="groupData in systemData.groups"
                           :key="groupData.group.id"
                           class="col-md-6 col-lg-4 mb-4">
                        <div class="card h-100 border">
                          <div class="card-header py-2 d-flex justify-content-between align-items-center"
                               :class="getPlatformHeaderClass(groupData.group.platform)">
                            <div>
                              <i :class="groupData.group.icon" class="me-1"></i>
                              <strong>{{ groupData.group.name }}</strong>
                            </div>
                            <span class="badge bg-white text-dark">
                              {{ getSelectedCountForGroup(groupData.roles) }}/{{ (groupData.roles && groupData.roles.length) || 0 }}
                            </span>
                          </div>
                          <div class="card-body py-2" style="max-height: 250px; overflow-y: auto;">
                            <!-- Select All for Group -->
                            <div v-if="groupData.roles && groupData.roles.length > 0" class="form-check mb-2 pb-2 border-bottom">
                              <input class="form-check-input"
                                     type="checkbox"
                                     :id="'groupAll' + groupData.group.id"
                                     :checked="isGroupFullySelected(groupData.roles)"
                                     @change="toggleGroupSelection(groupData.roles, $event)">
                              <label class="form-check-label fw-bold text-primary" :for="'groupAll' + groupData.group.id">
                                Select All
                              </label>
                            </div>

                            <!-- Individual Roles -->
                            <div v-for="role in (groupData.roles || [])" :key="role.id" class="form-check mb-1">
                              <input class="form-check-input"
                                     type="checkbox"
                                     :id="'role' + role.id"
                                     :checked="isSelected(role)"
                                     @change="toggleRoleSelection(role)">
                              <label class="form-check-label" :for="'role' + role.id" :title="role.description">
                                {{ role.role }}
                              </label>
                            </div>

                            <!-- No roles message -->
                            <div v-if="!groupData.roles || groupData.roles.length === 0" class="text-muted small text-center py-2">
                              No roles defined
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Empty State -->
                    <div v-if="systemData.groups.length === 0" class="text-center py-5 text-muted">
                      <i class="mdi mdi-shield-off-outline display-4 d-block mb-2"></i>
                      No role groups defined for this system
                    </div>
                  </div>
                </div>

                <!-- Selected Roles Summary -->
                <div class="mt-3 p-3 bg-light rounded">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Total Selected Permissions:</strong>
                      <span class="badge bg-primary ms-2">{{ selectedRoles.length }}</span>
                    </div>
                    <button class="btn btn-sm btn-outline-info"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#selectedRolesList">
                      <i class="mdi mdi-eye me-1"></i> View Selected
                    </button>
                  </div>
                  <div class="collapse mt-2" id="selectedRolesList">
                    <div class="d-flex flex-wrap gap-1">
                      <span v-for="role in selectedRoles" :key="role.id" class="badge bg-secondary">
                        {{ role.role }}
                        <i class="mdi mdi-close ms-1 cursor-pointer" @click="toggleRoleSelection(role)"></i>
                      </span>
                      <span v-if="selectedRoles.length === 0" class="text-muted">No permissions selected</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                <i class="mdi mdi-close me-1"></i> Cancel
              </button>
              <button v-if="getRight('UPDATE USER CATEGORY')"
                      @click="saveCategory"
                      class="btn btn-success"
                      :disabled="loading.save || !category.category || !category.systemID">
                <span v-if="loading.save">
                  <span class="spinner-border spinner-border-sm me-1"></span> Saving...
                </span>
                <span v-else>
                  <i class="mdi mdi-content-save me-1"></i> Save Changes
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">Multi-System Role Management</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  </body>
</template>

<script>
/* eslint-disable */
import { authUrl, execute, getRight } from "@/api";
import NavigationBar from "@/components/Navigation";

export default {
  name: "SetAccounts",
  components: { NavigationBar },
  data() {
    return {
      // Systems
      systems: [],
      filterSystemID: '',
      activeSystemTab: null,
      systemAccessArray: [],

      // Categories
      categories: [],
      totalUsers: 0,
      searchTerm: '',

      // Current category being edited
      category: {
        id: null,
        category: null,
        systemID: '',
        systemAccess: null,
        selectedRoles: null
      },

      // Roles data structured by system
      rightsData: [],
      selectedRoles: [],

      // UI State
      message: null,
      messageType: 'success',
      loading: {
        categories: false,
        roles: false,
        save: false,
        systems: false
      }
    };
  },
  computed: {
    filteredCategories() {
      let filtered = this.categories;

      // Filter by system
      if (this.filterSystemID) {
        filtered = filtered.filter(c => c.systemID == this.filterSystemID);
      }

      // Filter by search term
      if (this.searchTerm) {
        const term = this.searchTerm.toLowerCase();
        filtered = filtered.filter(c =>
            c.category?.toLowerCase().includes(term) ||
            c.systemName?.toLowerCase().includes(term)
        );
      }

      return filtered;
    }
  },
  mounted() {
    this.initializePage();
  },
  methods: {
    async initializePage() {
      await this.getSystems();
      await this.getCategories();
      await this.getRoles();
    },

    getRight(type) {
      return getRight(type);
    },

    // ==================== API CALLS ====================

    getSystems() {
      this.loading.systems = true;
      const data = new FormData();
      data.append("function", "getSystems");

      return execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.systems = res.data.data.systems;
              if (this.systems.length > 0) {
                this.activeSystemTab = this.systems[0].id;
              }
            }
          })
          .catch((e) => {
            this.showMessage(e.message || 'Failed to load systems', 'error');
          })
          .finally(() => {
            this.loading.systems = false;
          });
    },

    getCategories() {
      this.loading.categories = true;
      const data = new FormData();
      data.append("function", "getCategories");

      return execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.categories = res.data.data.categories;
              this.totalUsers = this.categories.reduce((sum, cat) => sum + parseInt(cat.count || 0), 0);
            } else {
              this.showMessage(res.data.message, 'error');
            }
          })
          .catch((e) => {
            this.showMessage(e.message || 'Failed to load categories', 'error');
          })
          .finally(() => {
            this.loading.categories = false;
          });
    },

    getRoles() {
      this.loading.roles = true;
      const data = new FormData();
      data.append("function", "getRolesBySystem");

      return execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.rightsData = res.data.data.systemRoles || [];
              // Set default active tab
              if (this.rightsData.length > 0 && !this.activeSystemTab) {
                this.activeSystemTab = this.rightsData[0].system.id;
              }
            } else {
              // Fallback: try old getRoles format
              this.getRolesOldFormat();
            }
          })
          .catch((e) => {
            console.error('getRolesBySystem failed, trying old format:', e);
            this.getRolesOldFormat();
          })
          .finally(() => {
            this.loading.roles = false;
          });
    },

    // Backward compatibility: load roles in old format
    getRolesOldFormat() {
      const data = new FormData();
      data.append("function", "getRoles");

      return execute(data, authUrl)
          .then((res) => {
            if (res.data.success && res.data.data.rights) {
              // Convert old format to new format
              const oldRights = res.data.data.rights;
              const groups = oldRights.map(item => ({
                group: {
                  id: item.type.type || item.type,
                  name: item.type.type || item.type,
                  code: item.type.type || item.type,
                  platform: (item.type.type === 'MOBILE' || item.type.type === 'SUPERVISORY PLATFORM') ? 'MOBILE' : 'DASHBOARD',
                  icon: 'mdi mdi-folder'
                },
                roles: item.roles || []
              }));

              this.rightsData = [{
                system: {
                  id: 1,
                  code: 'REVENUE',
                  name: 'Revenue Management System',
                  icon: 'mdi mdi-cash-register'
                },
                groups: groups
              }];

              this.activeSystemTab = 1;
            }
          })
          .catch((e) => {
            this.showMessage(e.message || 'Failed to load roles', 'error');
          });
    },

    saveCategory() {
      if (!this.category.category || !this.category.systemID) {
        this.showMessage('Please fill in category name and select a system', 'error');
        return;
      }

      this.loading.save = true;
      const data = new FormData();
      data.append("function", "updateCategories");
      data.append("category", JSON.stringify(this.category));
      data.append("selectedRoles", JSON.stringify(this.selectedRoles));
      data.append("systemAccess", JSON.stringify(this.systemAccessArray));
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.getCategories();
              this.showMessage('Category saved successfully!', 'success');
              // Close modal
              const modal = bootstrap.Modal.getInstance(document.getElementById('categoryModal'));
              if (modal) modal.hide();
            } else {
              this.showMessage(res.data.message, 'error');
            }
          })
          .catch((e) => {
            this.showMessage(e.message || 'Failed to save category', 'error');
          })
          .finally(() => {
            this.loading.save = false;
          });
    },

    deleteCategory(category) {
      if (!confirm(`Are you sure you want to delete "${category.category}"?`)) return;

      const data = new FormData();
      data.append("function", "deleteCategories");
      data.append("category", JSON.stringify(category));

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.getCategories();
              this.showMessage('Category deleted successfully!', 'success');
            } else {
              this.showMessage(res.data.message, 'error');
            }
          })
          .catch((e) => {
            this.showMessage(e.message || 'Failed to delete category', 'error');
          });
    },

    // ==================== CATEGORY MANAGEMENT ====================

    addNewCategory() {
      this.category = {
        id: null,
        category: null,
        systemID: this.systems.length > 0 ? this.systems[0].id : '',
        systemAccess: null,
        selectedRoles: null
      };
      this.selectedRoles = [];
      this.systemAccessArray = [];

      if (this.systems.length > 0) {
        this.activeSystemTab = this.systems[0].id;
      }
    },

    selectCategory(category) {
      this.category = { ...category };
      this.selectedRoles = [];
      this.systemAccessArray = [];

      // Parse selected roles
      if (category.selectedRoles) {
        try {
          this.selectedRoles = typeof category.selectedRoles === 'string'
              ? JSON.parse(category.selectedRoles)
              : category.selectedRoles;
        } catch (e) {
          this.selectedRoles = [];
        }
      }

      // Parse system access
      if (category.systemAccess) {
        try {
          this.systemAccessArray = typeof category.systemAccess === 'string'
              ? JSON.parse(category.systemAccess)
              : category.systemAccess;
        } catch (e) {
          this.systemAccessArray = [];
        }
      }

      // Set active tab to category's system
      if (category.systemID) {
        this.activeSystemTab = parseInt(category.systemID);
      }
    },

    onSystemChange() {
      // When primary system changes, set it as active tab
      if (this.category.systemID) {
        this.activeSystemTab = parseInt(this.category.systemID);
      }
    },

    // ==================== ROLE SELECTION ====================

    isSelected(role) {
      return this.selectedRoles.some(r => r.id === role.id);
    },

    toggleRoleSelection(role) {
      const index = this.selectedRoles.findIndex(r => r.id === role.id);
      if (index === -1) {
        this.selectedRoles.push(role);
      } else {
        this.selectedRoles.splice(index, 1);
      }
    },

    isGroupFullySelected(roles) {
      if (!roles || !Array.isArray(roles) || roles.length === 0) return false;
      return roles.every(role => this.isSelected(role));
    },

    toggleGroupSelection(roles, event) {
      if (!roles || !Array.isArray(roles)) return;

      if (event.target.checked) {
        // Add all roles that aren't already selected
        roles.forEach(role => {
          if (!this.isSelected(role)) {
            this.selectedRoles.push(role);
          }
        });
      } else {
        // Remove all roles in this group
        roles.forEach(role => {
          const index = this.selectedRoles.findIndex(r => r.id === role.id);
          if (index !== -1) {
            this.selectedRoles.splice(index, 1);
          }
        });
      }
    },

    selectAllForSystem(systemID) {
      const systemData = this.rightsData.find(s => s.system.id === systemID);
      if (!systemData) return;

      systemData.groups.forEach(groupData => {
        if (groupData.roles && Array.isArray(groupData.roles)) {
          groupData.roles.forEach(role => {
            if (!this.isSelected(role)) {
              this.selectedRoles.push(role);
            }
          });
        }
      });
    },

    deselectAllForSystem(systemID) {
      const systemData = this.rightsData.find(s => s.system.id === systemID);
      if (!systemData) return;

      const roleIdsToRemove = new Set();
      systemData.groups.forEach(groupData => {
        if (groupData.roles && Array.isArray(groupData.roles)) {
          groupData.roles.forEach(role => {
            roleIdsToRemove.add(role.id);
          });
        }
      });

      this.selectedRoles = this.selectedRoles.filter(r => !roleIdsToRemove.has(r.id));
    },

    getSelectedCountForSystem(systemID) {
      const systemData = this.rightsData.find(s => s.system.id === systemID);
      if (!systemData) return 0;

      let count = 0;
      systemData.groups.forEach(groupData => {
        if (groupData.roles && Array.isArray(groupData.roles)) {
          groupData.roles.forEach(role => {
            if (this.isSelected(role)) count++;
          });
        }
      });
      return count;
    },

    getSelectedCountForGroup(roles) {
      if (!roles || !Array.isArray(roles)) return 0;
      return roles.filter(role => this.isSelected(role)).length;
    },

    // ==================== UI HELPERS ====================

    getSystemBadgeClass(systemID) {
      const classes = {
        1: 'bg-success',
        2: 'bg-info',
        3: 'bg-warning text-dark'
      };
      return classes[systemID] || 'bg-secondary';
    },

    getSystemIcon(systemID) {
      const system = this.systems.find(s => s.id == systemID);
      return system?.icon || 'mdi mdi-application';
    },

    getPlatformHeaderClass(platform) {
      const classes = {
        'DASHBOARD': 'bg-primary text-white',
        'MOBILE': 'bg-success text-white',
        'API': 'bg-info text-white',
        'ALL': 'bg-secondary text-white'
      };
      return classes[platform] || 'bg-light';
    },

    showMessage(message, type = 'success') {
      this.message = message;
      this.messageType = type;
      setTimeout(() => this.clearMessage(), 4000);
    },

    clearMessage() {
      this.message = null;
    },

    filterCategories() {
      // This triggers the computed property to re-evaluate
    }
  }
};
</script>

<style scoped>
.nav-tabs-custom .nav-link {
  border: none;
  padding: 12px 20px;
  color: #6c757d;
  background: #f8f9fa;
  margin-right: 2px;
  border-radius: 4px 4px 0 0;
}

.nav-tabs-custom .nav-link.active {
  color: #495057;
  background: #fff;
  border: 1px solid #dee2e6;
  border-bottom: none;
  font-weight: 600;
}

.nav-tabs-custom .nav-link:hover:not(.active) {
  background: #e9ecef;
}

.cursor-pointer {
  cursor: pointer;
}

.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.card-header.bg-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

.card-header.bg-success {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%) !important;
}

.card-header.bg-info {
  background: linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%) !important;
}

.toast {
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.badge i.mdi-close:hover {
  color: #dc3545;
}

/* Scrollbar styling */
.card-body::-webkit-scrollbar,
.tab-content::-webkit-scrollbar {
  width: 6px;
}

.card-body::-webkit-scrollbar-track,
.tab-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.card-body::-webkit-scrollbar-thumb,
.tab-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.card-body::-webkit-scrollbar-thumb:hover,
.tab-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>